import '@fancyapps/fancybox';

export default () => {

};
